"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  wrapper: {
    maxWidth: props => {
      return props.maxWidth;
    },
    overflow: "hidden",
    margin: "auto"
  },
  grid: {
    margin: props => {
      return theme.spacing(-props.spacing / 2);
    },
    display: "flex",
    flexWrap: "wrap"
  },
  item: {
    width: props => {
      return (props.maxWidth + theme.spacing(props.spacing)) / props.gridColumns;
    },
    padding: props => {
      return theme.spacing(props.spacing / 2);
    },
    "&[data-size=medium]": {
      width: props => {
        return (props.maxWidth + theme.spacing(props.spacing)) / props.gridColumns * 2;
      }
    },
    "&[data-size=large]": {
      width: props => {
        return (props.maxWidth + theme.spacing(props.spacing)) / props.gridColumns * 4;
      }
    },
    "&[data-size=xl]": {
      width: props => {
        return props.maxWidth + theme.spacing(props.spacing);
      }
    }
  }
}));

const LayoutGrid = ({
  className,
  spacing = 2,
  padding = 0,
  maxWidth = 720,
  gridColumns = 4,
  children
}) => {
  const classes = useStyles({
    maxWidth,
    gridColumns,
    spacing,
    padding
  });
  return _react.default.createElement("section", {
    className: className || classes.wrapper
  }, _react.default.createElement("div", {
    className: className || classes.grid
  }, children.map((child, index) => {
    const item = _react.default.cloneElement(child);

    return _react.default.createElement("div", {
      className: classes.item,
      "data-size": item.props.size,
      key: index
    }, item);
  })));
};

var _default = LayoutGrid;
exports.default = _default;
module.exports = exports.default;